import React, { useEffect } from 'react';
import { Grid } from '@mui/material';

import FlightsSearchForm from '@shared/pages/Flights/FlightsSearchForm';
import TabsHeader from '@shared/components/TabsHeader';

import LoadingImage from '@shared/components/LoadingImage';

import PlatesList from '@shared/components/PlatesList';

import ImageSlider from '@shared/components/ImageSlider';

export default () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const typePlate = 0;

  return (
    <div style={{ overflow: 'hidden' }}>
      <LoadingImage site={'Maintenance'} isOpen={true} />
      <TabsHeader site={typePlate} />
      <div style={{ background: '#F3F3F3' }}>
        <FlightsSearchForm />
      </div>

      <Grid
        container
        justifyContent="center"
        alignItems="center"
        direction="column"
        style={{ backgroundColor: '#F2F2F2', paddingBottom: '50px' }}
      >
        <ImageSlider />

        <PlatesList
          title="Principales Destinos"
          IdServiceType={1}
          section={'main-destinations'}
          typePlate={typePlate}
        />
        <PlatesList
          title="Propuestas Irresistibles"
          IdServiceType={4}
          section={'irresistible-packages'}
          typePlate={2}
        />
      </Grid>
    </div>
  );
};
